module.exports = __webpack_public_path__ + "img/19.2ab40402.png";